<div class="conteudo">
  <app-mrr-skeleton *ngIf="valor === null"></app-mrr-skeleton>
  <app-mrr-up *ngIf="valor !== null && porcentagem >= 0" [fonte]="fonte" [porcentagem]="porcentagem" [valor]="valor"></app-mrr-up>
  <app-mrr-down *ngIf="valor !== null && porcentagem < 0" [fonte]="fonte" [porcentagem]="porcentagem" [valor]="valor"></app-mrr-down>
</div>
